export default "__VITE_ASSET__Ba4xS5lF__"